export const queryKeys = {
  properties: {
    all: () => ['properties'] as const,
    batch: (opts: object) => ['properties', 'batch', opts] as const,
    detail: (id: string) => ['properties', id] as const,
    adminAll: () => ['admin', 'properties'] as const,
    adminBatch: (opts: object) => ['admin', 'properties', 'batch', opts] as const,
  },

  inspections: {
    all: () => ['inspections'] as const,
    batch: (opts: object) => ['inspections', 'batch', opts] as const,
    detail: (id: string) => ['inspections', id] as const,
    byProperty: (propertyId: string) => ['properties', propertyId, 'inspections'] as const,
    byTask: (taskId: string) => ['tasks', taskId, 'inspection'] as const,
  },

  tasks: {
    all: () => ['tasks'] as const,
    batch: (opts: object) => ['tasks', 'batch', opts] as const,
    detail: (id: string) => ['tasks', id] as const,
    unassigned: () => ['tasks', 'unassigned'] as const,
  },

  user: {
    profile: () => ['user', 'profile'] as const,
    byId: (id: string) => ['user', 'by-id', id] as const,
  },

  users: {
    all: () => ['users'] as const,
    search: (role: string, search: string) => ['users', role, search] as const,
    searchAll: (search: string) => ['users', 'all', search] as const,
    staff: (sortBy?: string, sortOrder?: string) =>
      ['users', 'staff', sortBy ?? null, sortOrder ?? null] as const,
    propertyCount: (userId: string) => ['users', userId, 'property-count'] as const,
  },

  regions: {
    all: () => ['regions'] as const,
    adminAll: () => ['admin', 'regions'] as const,
  },

  /**
   * Feedback/admin query keys
   */
  feedback: {
    all: () => ['feedback'] as const,
    batch: (opts: object) => ['feedback', 'batch', opts] as const,
    byType: (type?: string) => ['feedback', type ?? 'all'] as const,
  },

  audits: {
    all: () => ['audits'] as const,
    batch: (opts: object) => ['audits', 'batch', opts] as const,
  },
} as const;

export type QueryKey = ReturnType<
  (typeof queryKeys)[keyof typeof queryKeys][keyof (typeof queryKeys)[keyof typeof queryKeys]]
>;
